var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "footer-button",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.visitLanding.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "20px",
            height: "20px",
            viewBox: "0 0 17 19",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Search-/-Explore",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Main---New-Nav",
                    transform: "translate(-185.000000, -747.000000)",
                    fill: "#000000",
                    "fill-rule": "nonzero"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group",
                        transform: "translate(185.000000, 747.000000)"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M7.22395833,3.384375 C7.08541667,3.24583333 6.86770833,3.24583333 6.72916667,3.384375 L4.90833333,5.20520833 L4.07708333,4.37395833 C3.93854167,4.23541667 3.72083333,4.23541667 3.58229167,4.37395833 L3.24583333,4.71041667 C3.12708333,4.82916667 3.10729167,5.046875 3.22604167,5.18541667 L4.65104167,6.946875 C4.78958333,7.125 5.046875,7.125 5.18541667,6.946875 L7.56041667,4.19583333 C7.67916667,4.05729167 7.67916667,3.859375 7.540625,3.72083333 L7.22395833,3.384375 Z",
                          id: "Path"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M13.6760417,4.82916667 L8.66875,4.82916667 C8.55,4.82916667 8.45104167,4.928125 8.45104167,5.046875 L8.45104167,5.91770833 C8.45104167,6.03645833 8.55,6.13541667 8.66875,6.13541667 L13.65625,6.13541667 C13.775,6.13541667 13.8739583,6.03645833 13.8739583,5.91770833 L13.8739583,5.046875 C13.8739583,4.90833333 13.7947917,4.82916667 13.6760417,4.82916667 Z",
                          id: "Path"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M7.22395833,7.71875 C7.08541667,7.58020833 6.86770833,7.58020833 6.72916667,7.71875 L4.90833333,9.53958333 L4.05729167,8.70833333 C3.91875,8.56979167 3.70104167,8.56979167 3.5625,8.70833333 L3.22604167,9.04479167 C3.10729167,9.16354167 3.0875,9.38125 3.20625,9.51979167 L4.63125,11.28125 C4.76979167,11.459375 5.02708333,11.459375 5.165625,11.28125 L7.540625,8.53020833 C7.659375,8.39166667 7.659375,8.19375 7.52083333,8.05520833 L7.22395833,7.71875 Z",
                          id: "Path"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M13.6760417,9.14375 L8.66875,9.14375 C8.55,9.14375 8.45104167,9.24270833 8.45104167,9.36145833 L8.45104167,10.2322917 C8.45104167,10.3510417 8.55,10.45 8.66875,10.45 L13.65625,10.45 C13.775,10.45 13.8739583,10.3510417 13.8739583,10.2322917 L13.8739583,9.36145833 C13.8739583,9.24270833 13.7947917,9.14375 13.6760417,9.14375 Z",
                          id: "Path"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M7.22395833,12.0333333 C7.08541667,11.8947917 6.86770833,11.8947917 6.72916667,12.0333333 L4.90833333,13.8541667 L4.07708333,13.0229167 C3.93854167,12.884375 3.72083333,12.884375 3.58229167,13.0229167 L3.24583333,13.359375 C3.12708333,13.478125 3.10729167,13.6958333 3.22604167,13.834375 L4.65104167,15.5958333 C4.78958333,15.7739583 5.046875,15.7739583 5.18541667,15.5958333 L7.56041667,12.8447917 C7.67916667,12.70625 7.67916667,12.5083333 7.540625,12.3697917 L7.22395833,12.0333333 Z",
                          id: "Path"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M13.6760417,13.478125 L8.66875,13.478125 C8.55,13.478125 8.45104167,13.5770833 8.45104167,13.6958333 L8.45104167,14.5666667 C8.45104167,14.6854167 8.55,14.784375 8.66875,14.784375 L13.65625,14.784375 C13.775,14.784375 13.8739583,14.6854167 13.8739583,14.5666667 L13.8739583,13.6958333 C13.8739583,13.5770833 13.7947917,13.478125 13.6760417,13.478125 Z",
                          id: "Path"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M14.5072917,0.0989583333 L2.51354167,0.0989583333 C1.1875,0.0989583333 0.0989583333,1.1875 0.0989583333,2.51354167 L0.0989583333,16.4864583 C0.0989583333,17.8125 1.1875,18.9010417 2.51354167,18.9010417 L14.4875,18.9010417 C15.8135417,18.9010417 16.9020833,17.8125 16.9020833,16.4864583 L16.9020833,2.51354167 C16.921875,1.1875 15.8333333,0.0989583333 14.5072917,0.0989583333 Z M15.5760417,16.4864583 C15.5760417,17.0802083 15.08125,17.575 14.4875,17.575 L2.51354167,17.575 C1.91979167,17.575 1.425,17.0802083 1.425,16.4864583 L1.425,2.51354167 C1.425,1.91979167 1.91979167,1.425 2.51354167,1.425 L14.4875,1.425 C15.08125,1.425 15.5760417,1.91979167 15.5760417,2.51354167 L15.5760417,16.4864583 Z",
                          id: "Shape"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("Quiz")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52536246", { render: render, staticRenderFns: staticRenderFns })
  }
}